import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaPolyfillUtility from "utilities/global/sparta-polyfill-utility/1.5.1/js/sparta-polyfill-utility";
/* global spartaEventsUtility */

/**
 * @name        Sparta Footnote Utility
 * @file        sparta-footnote-utility.js
 * @description Utility to manage footnotes.  The util will find all page footnotes, collect footnote content, write footnote content to a footnote section in the footer.  It will also handle onclick scrolling to footnotes.  WHen rules add/delete content with footnotes, the utility will refresh footnote content.
 * @author      FEE
 * @copyright   © 2016 Bank of America Corporation. All rights reserved.
 */

/*
  TODOs:
  1. fn links need unique IDs when duplicated. Order doesn't change?
  2. Rules: refresh the footnotes if any rules were fired to add/remove content
  3. Support Card dynamic fn from Cadets
*/

const EVENTS = {
  FOOTNOTES_REBUILD: 'FOOTNOTES_REBUILD.footnoteUtility',
  FOOTNOTE_CLICKED: 'FOOTNOTE_CLICKED.footnoteUtility',
  RULE_QUEUECOMPLETE: 'RULE-QUEUECOMPLETE.spartaRulesUtility'
};

class footnoteUtility {
  get EVENTS() {
    return EVENTS;
  }

  constructor() {
    this.$footnoteSection = null;
    this.$footnoteLinks = null;
    this.footnoteObj = {};
    this.footnoteOrder = [];

    this.init();
  }


  init() {
    this.$footnoteSection = $('.spa-footnotes-section');

    // die if page is missing a footnote section to write footnotes.
    if (!this.$footnoteSection.length) return;

    // Get page footnotes
    this.getFootnotes();

    // Update footnote section with fn content
    this.updateFootnoteSection();

    // Update footnote section with fn content
    this.updateFootnoteLinks();

    // Event listeners
    this.setupEventListeners();

    // Listen for Rebuild Events
    const checkForRebuild = this.checkForRebuild.bind(this);

    spartaEventsUtility.sub(this.EVENTS.FOOTNOTES_REBUILD, () => {
      checkForRebuild();
    }, true);

    spartaEventsUtility.sub(this.EVENTS.RULE_QUEUECOMPLETE, () => {
      $('[data-sparta-container]').on('webkitAnimationEnd oanimationend msAnimationEnd animationend',
        checkForRebuild());
    }, true);

    spartaEventsUtility.pub('FOOTNOTE_UTIL_RAN', true);
  }

  /**
   * getFootnotes: Search DOM and grab all footnotes
   * This will be called after rules are fired to grab new footnotes.
   * Create footnoteObj to hold fn
   * Create footnoteOrder array to hold order
   * @param selector: string - When provided it will search only from the selector. Useful when
   * having multiple section on the page, but each may have different footnotes to be displayed
   */
  getFootnotes(selector = null) {
    if (!selector) {
      selector = "body";
    }

    const footnoteObj = {};
    const footnoteOrder = [];
    let footnoteIndex = 0;

    this.$footnoteLinks = $(`${selector} a[data-footnote]`);

    this.$footnoteLinks.each(function footnoteLink(i) {
      const $this = $(this);
      const thisFn = $this.data() || {};

      // Set unique id. Without it, some footnote may have the same id
      const uniqueId = `${$this.attr('id')}_${i}`;
      $this.attr("id", uniqueId);

      //get the footnote by id and get the ADA text provided if it exists
      const fn = document.getElementById(uniqueId);
      const adaContainer = fn.querySelector('.ada-hidden');
      const adaText = (!adaContainer || adaContainer.innerText === 'adatext') ? null : adaContainer.innerText;

      if (typeof footnoteObj[thisFn.footnote] === 'undefined') {
        thisFn.footnoteIndex = footnoteIndex;
        thisFn.footnoteLinkId = uniqueId;
        thisFn.adaText = adaText;
        footnoteObj[thisFn.footnote] = thisFn;
        footnoteOrder.push(thisFn.footnote);
        footnoteIndex += 1;
      }
    });

    // Set final fn order & object
    this.footnoteObj = footnoteObj;
    this.footnoteOrder = footnoteOrder;
  }

  /**
   * updateFootnoteSection
   * Update footnote section with footnote content
   */
  updateFootnoteSection() {
    let newFootnotes = '<ol>';
    let counter = 0;

    // Get the back to content and label text, en and es.
    const ariaLabelBack = this.$footnoteSection.data('ariaLabelBack') ? ` aria-label="${this.$footnoteSection.data('ariaLabelBack')}"` : '';

    this.footnoteOrder.forEach((fn) => {
      counter += 1;

      const backToContentLink = this.$footnoteSection.data('backContent') ? ` <a href="#${this.footnoteObj[fn].footnoteLinkId}"${ariaLabelBack} class="spa-footnote-back">${this.$footnoteSection.data('backContent')}</a>` : '';

      newFootnotes += `<li><div id="ftn_${this.footnoteObj[fn].footnote}_content" class="ftn-wrapper">${this.footnoteObj[fn].footnoteContent}${backToContentLink}</div></li>`;
    }, this);

    newFootnotes += '</ol>';

    // insert new footnotes
    this.$footnoteSection.html(newFootnotes);
  }

  /**
   * getGlobalFootnoteAdaText
   * returns global ADA text based on language
   */
  getGlobalFootnoteAdaText() {
    try {
      //Since spaParams is not available in the store when footnote utility runs, get it from global
      const adaText = window.spaParams.global[sparta.language].footnote.adaText || 'Footnote'
      return adaText;
    }
    catch (err) {
      console.error(`Error fetching footnote global ADA text: ${err}`)
      return 'Footnote';
    }
  }

  /**
   * updateFootnoteLinks
   * Update footnote links with correct order #
   */
  updateFootnoteLinks() {
    for (let i = 0; i < this.footnoteOrder.length; i += 1) {
      const index = i + 1;
      const fnSelector = this.footnoteObj[this.footnoteOrder[i]];
      const $thisFn = $(`a[data-footnote=${fnSelector.footnote}]`);
      const newContent = `<span class="ada-hidden">${fnSelector.adaText || this.getGlobalFootnoteAdaText()} </span>${index}`;
      $thisFn.find('span.spa-footnote-order').html(newContent);
    }
  }

  /**
   * setupEventListeners
   * Click: Toggle open legal panel if its closed when footnotes are clicked
   * Rules
   */
  setupEventListeners() {
    $('body').on('click.footnoteLink', 'a[id^="ftn_"]', function footnoteLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();

      // Make the legal disclosure section visible before scrolling to it -
      // this is applies to the sales/global-footer 9 or higher
      spartaEventsUtility.pub(EVENTS.FOOTNOTE_CLICKED, e);


      const footnoteLink = this;

      // Dynamically set the href 'back to content' to the right trigger ID
      const targetSelector = document.querySelector(`#ftn_${footnoteLink.dataset.footnote}_content`);
      if (targetSelector) {
        const backToContentTarget = footnoteLink.getAttribute("id");
        const backToContentLink = targetSelector.querySelector(".spa-footnote-back");
        if (backToContentLink) {
          backToContentLink.setAttribute("href", `#${backToContentTarget}`);
        }
      }

      const $target = $(`#ftn_${footnoteLink.dataset.footnote}_content`);
      const $panelToggle = $('[data-toggle="#panel-legal"]');
      const $panelToggleHeader = $panelToggle.parents('.spa-toggle-heading');

      // TODO: spartaGlobal.pageData.scrollOffset no longer implemented.
      // offset = spartaGlobal.pageData.scrollOffset + 15 || 60,
      let offset = 60;
      let targetOffset = $target.offset();
      targetOffset = targetOffset ? targetOffset.top - offset : 0;
      let stickyOffset = 0;

      if (!$panelToggleHeader.hasClass('active')) {
        $panelToggle.find('> span').addClass('active');
        $panelToggleHeader.addClass('active');

        $('#panel-legal').addClass('active').slideDown({
          complete: function stickySlideDownComplete() {
            // TODO: spartaGlobal.pageData.scrollOffset no longer implemented.
            // offset = spartaGlobal.pageData.scrollOffset + 15 || 60;
            offset = 60;

            stickyOffset = footnoteUtility.getStickyOffset();
            offset = stickyOffset > offset ? stickyOffset : offset;
            targetOffset = $target.offset();
            targetOffset = targetOffset ? targetOffset.top - offset : 0;
            // animate to the footnote once legal panel slides down
            footnoteUtility.scrollToTarget($target, targetOffset);
          },
        });
      } else {
        stickyOffset = footnoteUtility.getStickyOffset();
        offset = stickyOffset > offset ? stickyOffset : offset;
        targetOffset = $target.offset();
        targetOffset = targetOffset ? targetOffset.top - offset : 0;
        footnoteUtility.scrollToTarget($target, targetOffset);
      }

    });

    // Setup back to content scroll
    $('[data-sparta-container]').on('blur.footnoteBack touchend.footnoteBack', '.spa-footnote-back', () => {
      $('.spa-footnote-back').css('display', 'none');
      $('.spa-footnotes-section .ftn-wrapper').removeAttr('tabindex');
    });

    $('body').on('click.footnoteBack touchstart.footnoteBack', '.spa-footnote-back', function footnoteBackClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const $backLink = $(this);
      const $footnoteLink = $($backLink.attr('href'));

      if ($footnoteLink.is(':visible')) {
        let linkOffset = $footnoteLink.offset();
        linkOffset = linkOffset ? linkOffset.top - footnoteUtility.getStickyOffset() : 0;
        footnoteUtility.scrollToTarget($footnoteLink, linkOffset);
      }
    });

    // Setup focus events for footnote content
    $('body').on('focus.footnote', '.spa-footnotes-section .ftn-wrapper', function footnoteFocus() {
      const $backLink = $(this).find('.spa-footnote-back');
      const $footnoteLink = $($backLink.attr('href'));

      // This keeps the 'back to content' link from showing if the footnote dosen't have a tabindex
      if ($footnoteLink.is(':visible') && this.getAttribute('tabindex')) {
        $backLink.css('display', 'inline');
      }
    });
  }

  checkForRebuild() {
    const oldLinks = this.$footnoteLinks;
    let newLinks = [];

    if (!oldLinks) {
      this.rebuildFootnotes();
    } else {
      newLinks = $('a[data-footnote]');

      if (newLinks.length !== oldLinks.length) {
        this.rebuildFootnotes();
      } else {
        for (let i = 0; i < newLinks.length; i += 1) {
          if (newLinks[i] !== oldLinks[i]) {
            this.rebuildFootnotes();
            return;
          }
        }
      }
    }
  }

  /**
   * To rebuild the footnotes
   * @param selector. If provided, it will build footnotes from the selector
   */
  rebuildFootnotes(selector = null) {

    if (this.$footnoteSection) {

      this.$footnoteSection.html();

      // Get page footnotes
      this.getFootnotes(selector);

      // Update footnote section with fn content
      this.updateFootnoteSection();

      // Update footnote section with fn content
      this.updateFootnoteLinks();
    }
  }

  static getStickyOffset() {
    let stickyOffset = 0;
    $('.spa-sticky').each(function spaStickyOffset() {
      stickyOffset += $(this).outerHeight();
    });
    return stickyOffset;
  }

  static scrollToTarget($el, targetOffset) {
    $('html, body').animate({
      scrollTop: targetOffset,
    }, 250, () => {
      if (($el).is('.spa-footnotes-section .ftn-wrapper')) {
        $el.attr('tabindex', '-1').focus();
      } else {
        $el.focus();
      }
    });
  }

  /**
   * Dynamic footnotes from rules & from external sources
   *
   */
  dynamicFootnotes() {

    /*
  dynamicFootnotes = function () {
      var newFootnotes = {},
          newFootnotesArr = [],
          thirdPartyFootnotes = {},
          footnotes = $('a[id^="ftn_"]');

      // hide and return out of this function if there are no footnotes
      if (!footnotes.length) {
          $target.hide();
          return;
      }

      // show if it isnt already visible
      if (!$target.is(':visible')) {
          $target.show();
      }

      //
      // loop through all footnotes in DOM and rebuild the footnote content
      //
      footnotes.each(function (index, footnote) {
          var footnoteName = $(this).data('footnote');

          if (allFootnotes[footnoteName] && !newFootnotes[footnoteName]) {
              newFootnotes[footnoteName] = allFootnotes[footnoteName];
          } else if (!allFootnotes[footnoteName]) {
              thirdPartyFootnotes[footnoteName] = {
                  content: footnote.dataset.footnoteContent,
                  label: footnote.dataset.footnoteName || "",
                  name: footnote.dataset.footnote
              };
          }
      });

      //
      // merging third party footnotes
      //
      $.each(thirdPartyFootnotes, function (footnoteName, footnote) {
          if (!newFootnotes[footnoteName]) {
              footnote.order = Object.keys(newFootnotes).length + 1;
              newFootnotes[footnoteName] = footnote;
              $('[data-footnote="' + footnoteName + '"]').text(footnote.order);
          }
      });

      // pushing object to array for sorting
      for (var footnoteKey in newFootnotes) {
          newFootnotesArr.push(newFootnotes[footnoteKey]);
      }

      // sorting footnotes by order
      newFootnotesArr.sort(function (obj1, obj2) {
          return obj1.order - obj2.order;
      });

      spartaFootnoteUtility.compileFootnoteContent(newFootnotesArr);
  };

  //
  // By default footnotes are being watched for changes to rebuild the footnote content area
  // when setting site parameter dynamicFootnotes to false they will all appear in footnote content area
  // page configuration will override site configuration
  //
  if (!spaParams.siteParams.dynamicFootnotes && spaParams.pageParams.dynamicFootnotes) {
      spaParams.siteParams.dynamicFootnotes = spaParams.pageParams.dynamicFootnotes;
  }

  if (!spaParams.pageParams.dynamicFootnotes || !spaParams.siteParams.dynamicFootnotes) {
      spartaFootnoteUtility.compileFootnoteContent(allFootnotes);
  } else {
      $(document).on('spa-rules-complete', spartaFootnoteUtility.dynamicFootnotes);
  }
    */
  }
}

export default new footnoteUtility();
